<template>
  <v-container fluid class="d-flex justify-center align-center fill-height">
    <v-row class="ma-0" justify="center">
      <v-col cols="12" md="10" class="text-center">
        <h1 class="font-weight-bold mb-3 poppinsFont">Referencia de Marca</h1>
        <p class="subtitle-1 mb-10 poppinsFont">Paleta visual de sinCarbono que inspira nuestro sistema de colores completo</p>

        <h1 class="font-weight-bold mb-3 poppinsFont">Referencia de Marca</h1>

        <!-- Colores Principales -->
        <h2 class="text-left font-weight-bold mb-4 mt-10 poppinsFont">Colores Principales de Marca</h2>
        <v-row dense>
        <v-col cols="12" sm="6" md="3" v-for="color in mainColors" :key="color.name">
            <v-card class="pa-4" elevation="2" rounded>
            <div
                :style="{
                background: color.gradient ? `linear-gradient(to right, ${color.gradient[0]}, ${color.gradient[1]})` : color.hex,
                height: '80px',
                borderRadius: '12px'
                }"
            ></div>
            <div class="mt-4">
                <div class="font-weight-medium">{{ color.name }}</div>
                <div class="caption grey--text">
                {{ color.gradient ? `from-[${color.gradient[0]}] to-[${color.gradient[1]}]` : color.hex }}
                </div>
                <div class="caption">{{ color.usage }}</div>
            </div>
            </v-card>
        </v-col>
        </v-row>

        <!-- Colores Secundarios -->
        <h2 class="text-left font-weight-bold mb-4 mt-10 poppinsFont">Colores Secundarios</h2>
        <v-row dense>
        <v-col cols="12" sm="6" md="3" v-for="color in secondaryColors" :key="color.name">
            <v-card class="pa-4" elevation="2" rounded>
            <div
                :style="{
                background: color.hex,
                height: '80px',
                borderRadius: '12px'
                }"
            ></div>
            <div class="mt-4">
                <div class="font-weight-medium">{{ color.name }}</div>
                <div class="caption grey--text">{{ color.hex }}</div>
                <div class="caption">{{ color.usage }}</div>
            </div>
            </v-card>
        </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Fonts',
  data() {
    return {
      mainColors: [
        { name: 'Gradiente Principal', gradient: ['#6366F1', '#8B5CF6'], usage: 'Identidad de marca, botones principales' },
        { name: 'Púrpura Base', hex: '#6366F1', usage: 'Acciones principales, links' },
        { name: 'Púrpura Intenso', hex: '#8B5CF6', usage: 'Acentos, estados hover' },
        { name: 'Amarillo Principal', hex: '#FFD60A', usage: 'CTA secundarios, alertas' }
      ],
      secondaryColors: [
        { name: 'Cian', hex: '#06B6D4', usage: 'Datos, gráficos, agua' },
        { name: 'Verde', hex: '#10B981', usage: 'Sostenibilidad, éxito' },
        { name: 'Verde Lima', hex: '#84CC16', usage: 'Energía renovable' },
        { name: 'Naranja', hex: '#F59E0B', usage: 'Alertas, energía' }
      ]
    };
  }
}

</script>
